export function centerOfPoints(datas) {
  let lat = 0.0;
  let lon = 0.0;
  let count = 0;

  for (let i = 0; i < datas.length; i++) {
    let data = datas[i];

    if (data.latitude !== null && data.latitude > 0 &&
      data.longitude !== null && data.longitude > 0) {
      lat += data.latitude;
      lon += data.longitude;

      count++;
    }
  }

  if (count > 0) {
    return {
      latitude: lat / count,
      longitude: lon / count,
      zoom: 9
    }
  } else {
    return {
      latitude: 51.919438,
      longitude: 19.145136,
      zoom: 6
    }
  }
}
